import { Button, Fade } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * A tab left open never asks for the service worker again on its own, so a
 * deploy would only reach it on the next navigation. The check is repeated
 * while the tab lives, and the new version waits for the user: reloading on
 * their behalf could throw away a form they are halfway through.
 */
const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

const UpdateAvailableButton = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      setInterval(() => {
        if (registration.installing || !navigator.onLine) return;
        registration.update();
      }, UPDATE_CHECK_INTERVAL_MS);
    },
  });

  return (
    <Fade in={needRefresh} unmountOnExit>
      <Button
        variant="contained"
        size="small"
        startIcon={<RefreshIcon fontSize="small" />}
        onClick={() => updateServiceWorker(true)}
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 16,
          zIndex: (theme) => theme.zIndex.snackbar,
          borderRadius: 999,
          textTransform: 'none',
          fontSize: 12,
          opacity: 0.85,
          boxShadow: 2,
          '&:hover': { opacity: 1 },
        }}
      >
        Nuova versione disponibile · Ricarica
      </Button>
    </Fade>
  );
};

export default UpdateAvailableButton;
